/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_7_QInputs */

const en_vc_faq_7_q = /** @type {(inputs: Vc_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft or Inkscape?`)
};

const zh_vc_faq_7_q = /** @type {(inputs: Vc_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 和 Inkscape 选哪个？`)
};

/**
* | output |
* | --- |
* | "VectorCraft or Inkscape?" |
*
* @param {Vc_Faq_7_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_7_q = /** @type {((inputs?: Vc_Faq_7_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_7_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_7_q(inputs)
	return zh_vc_faq_7_q(inputs)
});
export { vc_faq_7_q as "vc.faq.7.q" }